<template>
  <div>
      <canvas ref="signatureCanvas" class="signature mb-2"></canvas>
      <slot name="validation"></slot>
      <div>
          <button @click="clear" class="btn text-footer-color">Clear</button>
          <slot></slot>
      </div>
  </div>
</template>

<script>
import SignaturePad from 'signature_pad'

export default {
  name: 'SignaturePad',
  data () {
    return {
      pad: null,
      resizeObserver: null
    }
  },
  methods: {
    clear () {
      this.pad.clear()
      this.$emit('input', '')
    },
    resizeCanvas () {
      const canvas = this.$refs.signatureCanvas
      if (!canvas || !canvas.offsetWidth || !canvas.offsetHeight) {
        return
      }
      const ratio = Math.max(window.devicePixelRatio || 1, 1)
      canvas.width = canvas.offsetWidth * ratio
      canvas.height = canvas.offsetHeight * ratio
      canvas.getContext('2d').scale(ratio, ratio)
      if (this.pad) {
        this.pad.clear()
        this.$emit('input', '')
      }
    }
  },
  mounted () {
    const canvas = this.$refs.signatureCanvas
    this.pad = new SignaturePad(canvas)
    this.pad.addEventListener('endStroke', () => {
      this.$emit('input', this.pad.toDataURL())
    })
    this.resizeCanvas()
    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(() => this.resizeCanvas())
      this.resizeObserver.observe(canvas)
    } else {
      window.addEventListener('resize', this.resizeCanvas)
    }
  },
  beforeDestroy () {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    } else {
      window.removeEventListener('resize', this.resizeCanvas)
    }
  }
}
</script>

<style scoped>
.signature {
  background: #FFEDB2;
  border: 1px solid #121820;
  height: 280px;
  width: 100%;
  border-radius: 0.25rem;
}
@media screen and (max-width: 768px)  {
  .signature {
    height: 200px;
    width: 100%;
  }
}
</style>
